// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.label-review {
  font-family: "Omnes-ATT-W02-Medium";
}

.mediaStop {
  height: 140px;
  width: 281px !important;
}

.table {
  margin-bottom: 30px !important;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .icon-controls-approvalL {
    width: auto;
  }
}
input[type=text]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

.confirm-tab {
  margin: 0 16.66%;
}
.confirm-tab .profile-success-msg {
  color: hsl(150, 100%, 24%);
}
.confirm-tab .fanlist-without-accordion .pagination {
  display: none;
}
.confirm-tab .left {
  float: left;
  width: 6%;
  height: 100%;
  margin-right: 5px;
}
.confirm-tab .success-message {
  color: #007a3e;
  display: inline-block;
  width: 100%;
}
.confirm-tab .success-message h2 {
  margin-top: 9px;
  margin-bottom: 19px;
  font: 24px "Omnes-ATT-W02";
  color: #007a3e !important;
}
.confirm-tab .success-message p {
  margin: 0px;
  font-size: 16px;
}
.confirm-tab .icon-controls-approvalL {
  color: #007a3e !important;
}
.confirm-tab .fanlist-without-accordion + .settings-container {
  border: 0 none;
  padding: 0;
}
.confirm-tab .service-type {
  margin: 30px 0px 30px;
}
.confirm-tab .section-details {
  border-top: 1px solid #d2d2d2;
  padding: 30px 0;
}
.confirm-tab .section-details h3 {
  font: 24px "Omnes-ATT-W02";
}
.confirm-tab .section-details .separator {
  margin-bottom: 30px;
}
.confirm-tab .section-details .separator-end {
  margin-bottom: 10px;
}
.confirm-tab .accordion-grid {
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 20px;
}
.confirm-tab .message-box {
  background-color: hsl(0, 0%, 95%);
  border: 1px solid hsl(0, 0%, 95%);
  border-radius: 6px;
  margin: 10px 0 30px;
  padding: 20px;
}
.confirm-tab .message-box .profile-form {
  margin-top: 10px;
}
.confirm-tab .message-box .error {
  color: hsl(0, 66%, 49%);
  padding: 2px;
  font-size: 14px;
}
.confirm-tab .message-box .profile-input {
  padding: 0 5px 0 0;
}
.confirm-tab .message-box .profile-input .input-field {
  height: 54px;
}
.confirm-tab .message-box .profile-input input.error {
  border: 1px solid hsl(0, 66%, 49%);
}
.confirm-tab .message-box .profile-input input:focus {
  border: 1px solid hsl(0, 0%, 95%);
}
.confirm-tab .message-box .input-tooltip {
  bottom: 47px;
  font-size: 17px;
  left: 90%;
  position: relative;
}
.confirm-tab .message-box .input-tooltip .helper-text {
  top: 29px;
}
.confirm-tab .cta-session {
  border-top: 1px solid #d2d2d2;
  margin: 30px 0 60px;
  padding-top: 30px;
}
.confirm-tab .step-confirmation {
  color: hsl(150, 100%, 24%);
  margin-bottom: 30px;
}
.confirm-tab .step-confirmation i {
  color: hsl(150, 100%, 24%);
}
.confirm-tab .step-confirmation .desktop-view-msg i {
  font-size: 50px;
}
.confirm-tab .step-confirmation .desktop-view-msg h3 {
  color: #007a3e;
  margin-top: 14px;
  margin-bottom: 0px;
  font: 24px "Omnes-ATT-W02";
}
.confirm-tab .step-confirmation .desktop-view-msg h4 {
  color: #007a3e;
  font: 16px "Omnes-ATT-W02";
}
.confirm-tab .step-confirmation .desktop-view-msg .align-items-bottom {
  display: flex;
}
.confirm-tab .step-confirmation .mobile-view-msg {
  display: none;
}
.confirm-tab .app-list {
  list-style-type: disc;
  margin-left: 15px;
}
.confirm-tab .row-nowrap p {
  color: #007a3e;
  font-size: 16px;
  font-family: "Omnes-ATT-W02";
}
@media (max-width: 1024px) {
  .confirm-tab {
    margin: 0 15px;
  }
  .confirm-tab .cta-session {
    display: none;
    margin-bottom: 30px;
  }
  .confirm-tab .message-box img {
    display: none;
  }
  .confirm-tab .step-confirmation .desktop-view-msg {
    display: none;
  }
  .confirm-tab .step-confirmation .mobile-view-msg {
    display: flex;
  }
  .confirm-tab .error-container {
    margin: 0 -4% 15px -4%;
    border-radius: 0;
  }
  .confirm-tab .error-container div {
    border-radius: 0;
  }
  .confirm-tab .error-container .message {
    font-size: 12px;
  }
  .confirm-tab .section-details .separator {
    margin-bottom: 20px;
  }
  .confirm-tab .btn {
    margin: 0;
  }
  .confirm-tab .apple-certificate-info {
    font-size: 16px;
    padding: 0;
  }
  .confirm-tab .message-box {
    margin: 0 0 20px;
  }
  .confirm-tab .input-tooltip .helper-text {
    left: -237px;
  }
  .confirm-tab .grid-table {
    margin-left: -15px;
    margin-right: -15px;
  }
}
.confirm-tab .pull-right {
  padding-left: 20px;
  padding-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup/confirm/confirm.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJE;EACE,mCAAA;AAkJJ;;AA/IE;EACE,aAAA;EACA,uBAAA;AAkJJ;;AA/IE;EACE,8BAAA;AAkJJ;;AAhJE;EACE;IACE,WAAA;EAmJJ;AACF;AAjJE;EAA+B,aAAA;EAAe,QAAA;EAAW,SAAA;AAsJ3D;;AArJA;EACE,gBAAA;AAwJF;AAtJE;EACE,0BAAA;AAwJJ;AApJI;EACE,aAAA;AAsJN;AAnJE;EACE,WAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;AAqJJ;AAlJE;EACE,cAAA;EACA,qBAAA;EACA,WAAA;AAoJJ;AAnJI;EACE,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;AAqJN;AAnJI;EACE,WAAA;EACA,eAAA;AAqJN;AAjJE;EACE,yBAAA;AAmJJ;AAhJE;EACE,cAAA;EACA,UAAA;AAkJJ;AA/IE;EACE,qBAAA;AAiJJ;AA/IE;EACE,6BAAA;EACA,eAAA;AAiJJ;AA/II;EACE,0BAAA;AAiJN;AA1II;EACE,mBAAA;AA4IN;AAzII;EACE,mBAAA;AA2IN;AAxIE;EACE,gCAAA;EACA,mBAAA;AA0IJ;AAxIG;EACC,iCAAA;EACA,iCAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AA0IJ;AAxII;EACE,gBAAA;AA0IN;AAvII;EACE,uBAAA;EACA,YAAA;EACA,eAAA;AAyIN;AAtII;EACE,kBAAA;AAwIN;AAtIM;EACE,YAAA;AAwIR;AArIM;EACE,kCAAA;AAuIR;AApIM;EACE,iCAAA;AAsIR;AAlII;EACE,YAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AAoIN;AAlIM;EACE,SAAA;AAoIR;AA/HE;EACE,6BAAA;EACA,mBAAA;EACA,iBAAA;AAiIJ;AA9HE;EACE,0BAAA;EACA,mBAAA;AAgIJ;AA9HI;EACE,0BAAA;AAgIN;AA5HM;EACE,eAAA;AA8HR;AA3HM;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AA6HR;AA1HM;EACE,cAAA;EACA,0BAAA;AA4HR;AAzHM;EACE,aAAA;AA2HR;AAvHI;EACE,aAAA;AAyHN;AArHE;EACE,qBAAA;EACA,iBAAA;AAuHJ;AApHE;EACE,cAAA;EACA,eAAA;EACA,4BAAA;AAsHJ;AFxRI;EEHJ;IAyKI,cAAA;EAsHF;EApHE;IACE,aAAA;IACA,mBAAA;EAsHJ;EAlHI;IACE,aAAA;EAoHN;EA/GI;IACE,aAAA;EAiHN;EA9GI;IACE,aAAA;EAgHN;EA5GE;IACE,sBAAA;IACA,gBAAA;EA8GJ;EA5GI;IACE,gBAAA;EA8GN;EA3GI;IACE,eAAA;EA6GN;EAvGI;IACE,mBAAA;EAyGN;EArGE;IACE,SAAA;EAuGJ;EApGE;IACE,eAAA;IACA,UAAA;EAsGJ;EAnGE;IACE,gBAAA;EAqGJ;EAjGI;IACE,YAAA;EAmGN;EA/FE;IACE,kBAAA;IACA,mBAAA;EAiGJ;AACF;AA/FE;EACE,kBAAA;EACA,mBAAA;AAiGJ","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n\n  .label-review{\n    font-family: 'Omnes-ATT-W02-Medium';\n  }\n\n  .mediaStop{\n    height:140px;\n    width:281px !important;\n    }\n\n  .table{\n    margin-bottom:30px !important\n  }\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .icon-controls-approvalL {\n      width: auto;\n    }\n  }\n  input[type=text]::-ms-clear {  display: none; width : 0; height: 0; }\n.confirm-tab {\n  margin: 0 16.66%;\n\n  .profile-success-msg {\n    color: color(success, base);\n  }\n\n  .fanlist-without-accordion {\n    .pagination {\n      display: none;\n    }\n  }\n  .left {\n    float: left;\n    width: 6%;\n    height: 100%;\n    margin-right: 5px;\n  }\n\n  .success-message {\n    color:  #007a3e;\n    display: inline-block;\n    width: 100%;\n    h2{\n      margin-top: 9px;\n      margin-bottom: 19px;\n      font: 24px 'Omnes-ATT-W02';\n      color: #007a3e !important;\n    }\n    p {\n      margin: 0px;\n      font-size: 16px;\n    }\n  }\n\n  .icon-controls-approvalL{\n    color: #007a3e !important;\n  }\n\n  .fanlist-without-accordion + .settings-container {\n    border: 0 none;\n    padding: 0;\n  }\n\n  .service-type{\n    margin:30px 0px 30px;\n  }\n  .section-details {\n    border-top: 1px solid color(default, dark);\n    padding: 30px 0;\n\n    h3 {\n      font: 24px 'Omnes-ATT-W02';\n    }\n\n    // &.settings-container {\n    //   margin-bottom: 20px;\n    // }\n\n    .separator {\n      margin-bottom: 30px;\n    }\n\n    .separator-end {\n      margin-bottom: 10px;\n    }\n  }\n  .accordion-grid {\n    border-bottom: 1px solid  color(default, dark);\n    margin-bottom: 20px;\n  }\n   .message-box {\n    background-color: color(default, base);\n    border: 1px solid color(default, base);\n    border-radius: 6px;\n    margin: 10px 0 30px;\n    padding: 20px;\n\n    .profile-form {\n      margin-top: 10px;\n    }\n\n    .error {\n      color: color(danger, base);\n      padding: 2px;\n      font-size: 14px;\n    }\n\n    .profile-input {\n      padding: 0 5px 0 0;\n\n      .input-field {\n        height: 54px;\n      }\n\n      input.error {\n        border: 1px solid color(danger, base);\n      }\n\n      input:focus {\n        border: 1px solid color(default, base);\n      }\n    }\n\n    .input-tooltip {\n      bottom: 47px;\n      font-size: 17px;\n      left: 90%;\n      position: relative;\n\n      .helper-text {\n        top: 29px;\n      }\n    }\n  }\n\n  .cta-session {\n    border-top: 1px solid color(default, dark);\n    margin: 30px 0 60px;\n    padding-top: 30px;\n  }\n\n  .step-confirmation {\n    color: color(success, base);\n    margin-bottom: 30px;\n\n    i {\n      color: color(success, base);\n    }\n\n    .desktop-view-msg {\n      i {\n        font-size: 50px;\n      }\n\n      h3 {\n        color: #007a3e;\n        margin-top: 14px;\n        margin-bottom: 0px;\n        font: 24px 'Omnes-ATT-W02';\n      }\n\n      h4 {\n        color: #007a3e;\n        font: 16px 'Omnes-ATT-W02';\n      }\n\n      .align-items-bottom {\n        display: flex;\n      }\n    }\n\n    .mobile-view-msg {\n      display: none;\n    }\n  }\n\n  .app-list {\n    list-style-type: disc;\n    margin-left: 15px;\n  }\n\n  .row-nowrap p{\n    color : #007a3e;\n    font-size: 16px;\n    font-family: 'Omnes-ATT-W02';\n  }\n\n  @include respond-to (small) {\n    margin: 0 15px;\n\n    .cta-session {\n      display: none;\n      margin-bottom: 30px;\n    }\n\n    .message-box {\n      img {\n        display: none;\n      }\n    }\n\n    .step-confirmation {\n      .desktop-view-msg {\n        display: none;\n      }\n\n      .mobile-view-msg {\n        display: flex;\n      }\n    }\n\n    .error-container {\n      margin: 0 -4% 15px -4%;\n      border-radius: 0;\n\n      div {\n        border-radius: 0;\n      }\n\n      .message {\n        font-size: 12px;\n      }\n\n    }\n\n    .section-details {\n      .separator {\n        margin-bottom: 20px;\n      }\n    }\n\n    .btn {\n      margin: 0;\n    }\n\n    .apple-certificate-info {\n      font-size: 16px;\n      padding: 0;\n    }\n\n    .message-box {\n      margin: 0 0 20px;\n    }\n\n    .input-tooltip {\n      .helper-text {\n        left: -237px;\n      }\n    }\n\n    .grid-table {\n      margin-left: -15px;\n      margin-right: -15px;\n    }\n  }\n  .pull-right {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
